import '../assets/css/footer.css';

export const Footer = () => {
    const element = (
    <>
        <div className="aside-footer container-fluid bg-color-blue-1" id="sidebar-footer">
            <div className="row">
                <div className="col-12">
                    <ul className="footer-links px-3 pt-3">
                        <li><a target="_blank" href="https://www.k12.com/terms-of-use/">Terms</a></li>
                        <li><a target="_blank" href="https://www.stridelearning.com/privacy-policy/">Privacy</a></li>
                        <li><a target="_blank" href="https://www.k12.com/ip-policy/">Copyright</a></li>
                        <li><a target="_blank" href="https://www.k12.com/accessibility/">Accessibility</a></li>
                    </ul>
                </div>
                <div className="col-12">
                    <div className="copyright px-3 pb-3">
                        Copyright © 2025 Stride, Inc. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    </>
    )
    return element; 
}